import React, { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedTodo } from './slice/buckets';
import { selectBuckets } from './slice/buckets';
import { CATEGORIES } from './constants';
import BucketCard from './BucketCard';

// Helper: initial positions and sizes for demo
const getInitialPositions = (buckets) => {
    const positions = {};
    const sizes = {};
    let y = 20;
    buckets.forEach((b, i) => {
        positions[b.rowID] = { x: 40 + (i % 3) * 160, y: y + Math.floor(i / 3) * 100 };
        sizes[b.rowID] = { width: 180, height: 80 };
    });
    return { positions, sizes };
};

const BucketView = ({ buckets, toggleExpandBucket }) => {
    const dispatch = useDispatch();
    const [selectedCategory, setSelectedCategory] = useState(CATEGORIES[0]);


    // Only parent buckets (no parentRowID)
    const parentBuckets = buckets.filter((b) => !b.parentRowID);
    const catBuckets = parentBuckets.filter((b) => b.category === selectedCategory);

    return (<>
        <div style={{ display: 'flex', justifyContent: 'center', marginRight: "10px", flexDirection: 'column', justifyContent: 'right', marginBottom: "3px", gap: 8 }}>
            {CATEGORIES.map((cat) => (
                <button
                    key={cat}
                    onClick={() => setSelectedCategory(cat)}
                    style={{
                        padding: '8px 18px',
                        borderRadius: 8,
                        border: selectedCategory === cat ? '2px solid #6a0' : '1px solid #ccc',
                        background: selectedCategory === cat ? '#eaffea' : '#fff',
                        color: selectedCategory === cat ? '#2a2' : '#555',
                        fontWeight: selectedCategory === cat ? 'bold' : 'normal',
                        cursor: 'pointer',
                    }}
                >
                    {cat}
                </button>
            ))}
        </div>

        <div style={{ width: '100%', minHeight: 500 }}>

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                    gap: 16,
                    minHeight: 400,
                    border: '2px solid #eee',
                    borderRadius: 16,
                    margin: '0 auto',
                    background: '#e7e7e7',
                    position: 'relative',
                    boxShadow: '0 2px 8px #0001',
                    padding: 8,
                    overflowY: 'auto',
                    maxHeight: '70vh',
                }}
            >
                {catBuckets.map((bucket) => (
                    <div
                        key={bucket.rowID}
                        style={{
                            width: 180,
                            height: 80,
                            zIndex: 2,
                            position: 'relative',
                        }}
                        onClick={() => dispatch(setSelectedTodo(bucket))}
                    >
                        <BucketCard bucket={bucket} buckets={buckets} />
                    </div>
                ))}
            </div>
        </div>
    </>
    )
}
export default BucketView;
